import { useEffect, useState } from 'react';
import axios from 'axios';
import './RecommendPage.css';

import searchIcon from './../../images/search-icon.svg';
import searchEmoji from './../../images/search.png';

const RecommendPage = ({
    setCurrentPage,
    newEventCategory,
    userLang,
    translations,
    setNewEventAddress,
    setNewRecommendId,
    isFullScreenMode,
}) => {
    const [recommendList, setRecommendList] = useState([]);
    const [selectedRecommend, setSelectedRecommend] = useState(null);

    useEffect(() => {
        const loadingRecommend = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/ad/list/category',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                            'Accept-Language': userLang,
                        },
                        params: {
                            subCategoryId: newEventCategory.id,
                        },
                    }
                );

                if (response.data.success) {
                    setRecommendList(response.data.result);
                    setSelectedRecommend(response.data.result[0]);
                }
            } catch (error) {
                console.error('Ошибка получение рекомендаций ', error);
            }
        };
        loadingRecommend();
    }, []);

    useEffect(() => {
        console.log('recommendList: ', recommendList);
        console.log('userLang: ', userLang);
        console.log('newEventCategory.id: ', newEventCategory.id);
    }, [recommendList, userLang, newEventCategory]);

    const handleMapClick = () => {
        setCurrentPage('NewMapPage');
    };

    const handleRecommendClick = (element) => {
        setSelectedRecommend(element);
    };

    const handleJoinClick = (recommends) => {
        setNewEventAddress(recommends.address);
        setNewRecommendId(recommends.id);
        setCurrentPage('AddEventPage');
    };

    return (
        <div
            className={
                isFullScreenMode
                    ? 'recommend__wrapper_full'
                    : 'recommend__wrapper'
            }
        >
            <div className='recommend__search_wrapper'>
                <div className='recommend__search' onClick={handleMapClick}>
                    <img src={searchIcon} className='recommend__search_icon' />
                    <p className='recommend__search_title'>
                        {translations.recommendSearch}
                    </p>
                    <img src={searchEmoji} className='recommend__filter_icon' />
                </div>
            </div>

            <div className='recommend__item_wrapper'>
                {selectedRecommend && (
                    <div key={selectedRecommend.id} className='recommend__item'>
                        <div className='recommend__item_name'>
                            <img
                                src={`https://mepointserver.ru${selectedRecommend.image}`}
                                alt={selectedRecommend.name}
                                className='recommend__items_image'
                            />
                            <h3>{selectedRecommend.name}</h3>
                        </div>
                        <div className='recommend__item_info'>
                            <h3>{selectedRecommend.eventSubCategoryName}</h3>
                            <p className='recommend__item_description'>
                                {translations.description}
                            </p>
                            <div className='recommend__item_address'>
                                <p className='recommend__item_address_text'>
                                    {selectedRecommend.description}
                                </p>
                                <p className='recommend__item_address_text'>
                                    {selectedRecommend.address}
                                </p>
                            </div>
                            <button
                                className='recommend__btn'
                                onClick={() =>
                                    handleJoinClick(selectedRecommend)
                                }
                            >
                                {translations.join}
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <div className='recommend__items_group'>
                {recommendList.length > 0 &&
                    recommendList.map((recommend) => (
                        <div
                            key={recommend.id}
                            className='recommend__items'
                            onClick={() => handleRecommendClick(recommend)}
                        >
                            <img
                                src={`https://mepointserver.ru${recommend.image}`}
                                alt={recommend.name}
                                className='recommend__item_image'
                            />
                        </div>
                    ))}
                {Array.from({ length: 5 - recommendList.length }).map(
                    (_, index) => (
                        <div key={index} className='recommend__items'>
                            <div className='recommend__item_text'>AD</div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default RecommendPage;
